import Lenis from "lenis";
import "lenis/dist/lenis.css";

/**
 * Lenis smooth scroll — scroll-asset-prd.md §5. Mounted once at the AppShell
 * root; prefers-reduced-motion never mounts it (native scroll fallback).
 * Module-scoped instance so ScrollToTop (App.tsx) can delegate without props.
 */
let lenis: Lenis | null = null;

/** Mount from AppShell's effect — returns the cleanup. No-op under reduced motion. */
export function startLenis(): () => void {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
  const instance = new Lenis({ lerp: 0.1, autoRaf: true });
  lenis = instance;
  return () => {
    instance.destroy();
    if (lenis === instance) lenis = null;
  };
}

/** Route-change scroll: number = offset (immediate reset), string = hash anchor.
 * URL hashes are user-typed — an invalid selector must not throw out of a React effect. */
export function scrollToTarget(target: number | string, immediate = false) {
  try {
    if (lenis) {
      lenis.scrollTo(target, { immediate });
    } else if (typeof target === "number") {
      window.scrollTo(0, target);
    } else {
      document.querySelector(target)?.scrollIntoView();
    }
  } catch {
    // Malformed hash selector — ignore, stay at current scroll position.
  }
}
